<script lang="ts">
import { defineComponent } from "vue";
import StarIcon from "./StarIcon.vue";

export default defineComponent({
  name: "Vue3StarRatings",
  components: { StarIcon },
  props: {
    starSize: {
      type: String,
      default: "28",
    },
    numberOfStars: {
      type: Number,
      default: 5,
    },
    modelValue: {
      type: Number,
    },
    disableClick: {
      type: Boolean,
      default: false,
    },
    step: {
      type: Number,
      default: 0.5,
    },
  },
  data() {
    return {
      rating: this.modelValue || 0,
    };
  },
  computed: {
    roundedRating(): number {
      return this.rounded(this.rating, 0);
    },
    percent(): string {
      return (this.roundedRating / this.numberOfStars) * 100 + "%";
    },
  },
  watch: {
    roundedRating() {
      this.$emit("update:modelValue", this.roundedRating);
    },
  },
  mounted() {
    const starsCont = this.$refs["starsContainer"] as HTMLDivElement;
    const self = this;
    starsCont.addEventListener("click", function (e) {
      const relativeX = e.pageX - this.offsetLeft;
      self.rating = (relativeX / this.offsetWidth) * self.numberOfStars;
    });
  },
  methods: {
    rounded(value: number, decimalPlaces: number) {
      const power = 10 ** decimalPlaces;
      return Math.round(value * power) / power;
    },
    generateSameWidthAndHeight(size: string | number) {
      return {
        width: size + "px",
        height: size + "px",
      };
    },
  },
});
</script>

<template>
  <div class="rating">
    <div
      ref="starsContainer"
      class="stars"
      :style="{ pointerEvents: disableClick ? 'none' : 'auto' }"
    >
      <div class="stars-outer">
        <star-icon
          v-for="i in numberOfStars"
          :key="i"
          :style="{
            ...generateSameWidthAndHeight(starSize),
          }"
        >
        </star-icon>
      </div>
      <div
        class="stars-inner"
        :style="{ width: percent }"
      >
        <star-icon
          v-for="i in numberOfStars"
          :key="i"
          checked
          :style="{
            ...generateSameWidthAndHeight(starSize),
          }"
        >
        </star-icon>
      </div>
    </div>
  </div>
</template>

<style scoped>
.rating {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.rating button {
  border: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
}

.rating button svg {
  fill: currentColor;
}

.stars {
  display: inline-block;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
}

.stars-outer,
.stars-inner {
  height: inherit;
}

.stars-inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  max-width: 100%;
  min-width: 0;
  white-space: nowrap;
  transition: 320ms cubic-bezier(0.075, 0.82, 0.165, 1);
  overflow: hidden;
}

.stars svg {
  display: inline-block;
  fill: currentColor;
  cursor: pointer;
  margin-left: 2px;
  margin-right: 2px;
}
</style>
